import script from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"

import "./BaseAlert.vue?vue&type=style&index=0&id=70417498&scoped=true&lang=css"

import exportComponent from "/Users/river/dev/packages/plugin-openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70417498"]])

export default __exports__